import * as React from "react"
import { PropsWithChildren } from "react"

import { Contact, Navigation, NavigationContainer } from "./styles"
import { Page, useNavigationData } from "../../../hooks/use-navigation-data"
import NavigationBarComponent from "../navigation-bar"
import BrandComponent from "../brand"
import ButtonComponent from "../../shared/button"
import { useTranslations } from "../../../hooks/use-translations"


export default function NavigationComponent(props: PropsWithChildren<{ locale: string }>) {
  const { pages, brand, company } = useNavigationData()
  const messages = useTranslations(props.locale)
  const localizedPages = pages.filter((page: Page) => page.langKey === props.locale)

  return (
    <Navigation>
      <NavigationContainer>
        <BrandComponent root={localizedPages[0].slug} brand={brand}/>
        <NavigationBarComponent pages={localizedPages}/>
        <Contact>
          <ButtonComponent icon={"phone"} href={`tel:${company.tel}`}>{messages.nav.contact}</ButtonComponent>
        </Contact>
      </NavigationContainer>
    </Navigation>
  )
}
